var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorreo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.75 14.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b3b3b3;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.75,2.25s0,0,0-.01c-.01-1.24-1.01-2.24-2.23-2.24H2.23C1.01,0,.01,1,0,2.24c0,0,0,0,0,.01,0,0,0,0,0,.01v10.19c0,1.25,1,2.27,2.23,2.27h13.29c1.23,0,2.23-1.02,2.23-2.27V2.27s0,0,0-.01ZM2.23,1.13h13.29c.51,0,.95.37,1.06.86l-7.71,5.52L1.16,2c.12-.5.55-.86,1.06-.86ZM15.52,13.59H2.23c-.6,0-1.09-.51-1.09-1.13V3.37l7.41,5.31c.1.07.21.11.33.11s.23-.04.33-.11l7.41-5.31v9.09c0,.62-.49,1.13-1.09,1.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/CORREO.1398ae87b67e8e2648bc1314b1b3db2e.svg";
export { ForwardRef as ReactComponent };